import React from "react"

import { ProductPosition } from "shared/types/ProductPosition"

import { NewProductPositionOverlay } from "./NewProductPositionOverlay"
import { useNewProductPositionOverlayModel } from "./model/useNewProductPositionOverlayModel"

export interface NewProductPositionOptions {
  hideProject?: boolean
  excludedProjectIDs?: string[]
  defaultValues?: Partial<ProductPosition>
  title?: string
  submitButtonText?: string
}

export interface NewProductPositionOverlayPayload
  extends NewProductPositionOptions {
  projectID: string
}

export interface NewProductPositionOverlayConnectorProps {
  payload: NewProductPositionOverlayPayload
}

export const NewProductPositionOverlayConnector = React.memo(
  (props: NewProductPositionOverlayConnectorProps) => (
    <NewProductPositionOverlay {...useNewProductPositionOverlayModel(props)} />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    NEW_PRODUCT_POSITION_OVERLAY: NewProductPositionOverlayPayload
  }
}
